package dev.kotlinfest._2026.pages

import androidx.compose.runtime.*
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.*
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.layout.NoLayout
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobwebx.frontmatter.*
import com.varabyte.kobwebx.markdown.*

@InitRoute
fun initSponsorshipPage(ctx: InitRouteContext) {
    ctx.data.add(MarkdownContext("Sponsorship.md", FrontMatterElement.Builder { addScalar("title", "ご協賛のお願い"); addScalar("description", "Kotlin Fest 2026の協賛企業の募集は終了しました。たくさんのお申し込みをいただき、ありがとうございました。"); }))
}

@Page("/sponsorship")
@Layout(".components.layouts.MarkdownLayout")
@Composable
fun SponsorshipPage() {
    org.jetbrains.compose.web.dom.H2(attrs = { id("協賛企業の募集は終了しました") }) {
        org.jetbrains.compose.web.dom.Text("協賛企業の募集は終了しました")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("たくさんのお申し込みをいただき、ありがとうございました。")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("ご協賛いただいた企業の皆様に、心より御礼申し上げます。")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("Kotlin Festは「Kotlinを愛でる」をビジョンに、Kotlin™に関する知見の共有と、Kotlinファンの交流の場を提供する技術カンファレンスです。")
    }
    org.jetbrains.compose.web.dom.P {
        org.jetbrains.compose.web.dom.Text("皆様のご支援とともに、Kotlin Fest 2026を開催いたします。")
    }
}
